<template>
  <div class="sessions">
    <hero
        v-if="!isInApp"
    />
    <trending-sessions
      :sessions="sessions"
      :loading="loading"
      :bookMarks="bookMarks"
      :followedBloggers="followedBloggers"
      @bookMarkBlog="handleToggleShelfSessions"
    />
    <Form />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "@/components/layout/Form";
import Hero from "@/components/other-pages/sessions/HeroSessionsList";
import TrendingSessions from "@/components/other-pages/sessions/TrendingSessions";

export default {
  name: "Listing_Sessions",
  components: {
    Hero,
    Form,
    TrendingSessions
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    isInApp() {
      return this.$route.fullPath
        ? this.$route.fullPath.includes("/app")
        : false;
    }
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue.uid) {
        //this.getCollectedCornerSessions();
      }
    }
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    this.$store.dispatch("listings/getListSessions").then(sessions => {
      this.sessions = sessions;
      this.loading = false;
    });

    if (this.user) {
      this.getCollectedCornerSessions();
    }

    // this.currentPath = this.$route.fullPath;
  },
  methods: {
    getCollectedCornerSessions() {
      if (this.user) {
        this.$store
          .dispatch("user/getCollectedCornerPublishings", this.user.uid)
          .then(sessions => {
            this.shelvedSessions = sessions;
          });
      }
    },
    handleToggleShelfSessions(event) {}
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:title", content: "Our Daily Focus" },
        {
          name: "twitter:description",
          content: "The Blog of JourneyBinder.com"
        },
        // image must be an absolute path
        { name: "twitter:image", content: this.logo },
        // Facebook OpenGraph
        { property: "og:title", content: "Our Blog" },
        { property: "og:site_name", content: "Our Daily Focus" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: "The Blog of JourneyBinder.com" }
      ]
    };
  },
  data() {
    return {
      currentPath: "",
      loading: false,
      sessions: [],
      bookMarks: [],
      followedBloggers: [],
      shelvedSessions: [],
      tags: [],
      logo: "https://journeybinder.com/img/main_logo.39bf51d2.png"
    };
  },
};
</script>

<style lang="scss" scoped>
.sessions {
  position: relative;
  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  padding-top: 72px;
  @media (min-width: 767px) {
    padding-top: 130px;
  }

  .horizontal-line {
    border-top: 1px solid #ddd;
  }
}
</style>
